import { render } from "./AccountAddresses.vue?vue&type=template&id=7722a52f&lang=pug"
import script from "./AccountAddresses.vue?vue&type=script&lang=js"
export * from "./AccountAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__